module.exports = __webpack_public_path__ + "img/Invention patent application.2cf6a8e5.png";